import * as React from 'react';
import { type Id, toast, type ToastContent, type ToastContentProps, type ToastOptions } from 'react-toastify';
import { buildQaTrackingEntityProps } from '@/shared/modules/qa-tracking-entity';
const QA_TRACKING_ENTITY_ID = 'notification.system.toast';
const isToastContentRenderFunction = <TData = unknown,>(content: ToastContent<TData>): content is (props: ToastContentProps<TData>) => React.ReactNode => {
  return typeof content === 'function';
};
type TData = ToastContentProps['data'];
type ToastFnType = typeof toast.loading | typeof toast.success | typeof toast.info | typeof toast.error | typeof toast.warning | typeof toast.warn;
const createToasterSpecificFn = (toastFn: ToastFnType) => {
  const toasterSpecificFn = (content: ToastContent<TData>, options?: ToastOptions): Id => {
    const qaEntities = buildQaTrackingEntityProps(QA_TRACKING_ENTITY_ID);
    if (isToastContentRenderFunction(content)) {
      return toastFn<TData>(props => {
        return <div {...qaEntities}>{content(props)}</div>;
      }, options);
    }
    return toastFn<TData>(<div {...qaEntities}>{content}</div>, options);
  };
  return toasterSpecificFn;
};
const toaster = (content: ToastContent<TData>, options?: ToastOptions): Id => {
  const qaEntities = buildQaTrackingEntityProps(QA_TRACKING_ENTITY_ID);
  if (isToastContentRenderFunction(content)) {
    return toast<TData>(props => {
      return <div {...qaEntities}>{content(props)}</div>;
    }, options);
  }
  return toast(<div {...qaEntities}>{content}</div>, options);
};
toaster.loading = createToasterSpecificFn(toast.loading);
toaster.success = createToasterSpecificFn(toast.success);
toaster.info = createToasterSpecificFn(toast.info);
toaster.error = createToasterSpecificFn(toast.error);
toaster.warning = createToasterSpecificFn(toast.warning);
toaster.warn = createToasterSpecificFn(toast.warn);
export { toaster };